import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "./Tabs";

// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../../FluidSections";
import { RCL } from "../../RCL";

const FluidTabs = ({ activeKey, variant, cards, locale }) => (
	<Tabs activeKey={activeKey} variant={variant}>
		{cards.map(card => (
			<Tab
				key={card.id}
				eventKey={card.cardKey}
				title={card.cardText}
				subTitle={card.cardSubText}
				newLabel={card.showNewBanner && RCL({ searchKey: "new" })}
				icon={card.icon}>
				<FluidSections data={card.cardContentComponents} useWrapper={false} locale={locale} />
			</Tab>
		))}
	</Tabs>
);

FluidTabs.propTypes = {
	activeKey: PropTypes.string,
	variant: PropTypes.oneOf(["classic", "tide"]),
	cards: PropTypes.arrayOf(PropTypes.object),
	locale: PropTypes.string,
};
FluidTabs.defaultProps = {
	activeKey: undefined,
	variant: "classic",
	cards: null,
	locale: null,
};

export default FluidTabs;
export { FluidTabs };
